import React from 'react';
import classes from './InterestRateLegend.css';

const interestRateLegend = () => {
    return (
        <div className={classes.InterestRateLegend}>

            <p>
                As a reference for Interest Rate, the below are US Interm Gov Fund returns for each market condition.
            </p>

            <table>
                <thead>
                <tr>
                    <th className={classes.left}>Market</th>
                    <th className={classes.left}>Rate Move</th>
                    <th className={classes.right}>Return</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className={classes.left}>
                            <span>
                                Bear
                            </span>
                    </td>
                    <td className={classes.center}>
                            <span>
                                +300 bps
                            </span>
                    </td>
                    <td className={classes.right}>
                            <span>
                               -8.94%
                            </span>
                    </td>
                </tr>

                <tr>
                    <td className={classes.left}>
                            <span>
                                Little Bear
                            </span>
                    </td>
                    <td className={classes.center}>
                            <span>
                                +150 bps
                            </span>
                    </td>
                    <td className={classes.right}>
                            <span>
                               -2.56%
                            </span>
                    </td>
                </tr>

                <tr>
                    <td className={classes.left}>
                            <span>
                                Normal
                            </span>
                    </td>
                    <td className={classes.center}>
                            <span>
                                Flat
                            </span>
                    </td>
                    <td className={classes.right}>
                            <span>
                               3.83%
                            </span>
                    </td>
                </tr>

                <tr>
                    <td className={classes.left}>
                            <span>
                                Little Bull
                            </span>
                    </td>
                    <td className={classes.center}>
                            <span>
                               -150 bps
                            </span>
                    </td>
                    <td className={classes.right}>
                            <span>
                               10.22%
                            </span>
                    </td>
                </tr>

                <tr>
                    <td className={classes.left}>
                            <span>
                                Bull
                            </span>
                    </td>
                    <td className={classes.center}>
                            <span>
                               -300 bps
                            </span>
                    </td>
                    <td className={classes.right}>
                            <span>
                               16.62%
                            </span>
                    </td>
                </tr>

                </tbody>

            </table>

        </div>
    );
};

export default interestRateLegend;


// WEBPACK FOOTER //
// ./src/components/InterestRateLegend/InterestRateLegend.js